<template>
  <b-modal
    id="modal_form"
    size="lg"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
    modal-class="unidade-modal-custom"
    body-class="unidade-modal-body"
    header-class="unidade-modal-header"
    footer-class="unidade-modal-footer"
  >
    <form
      class="unidade-form"
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-0">
        <b-row class="mx-0 first-section-grid">
          <b-col md="4" sm="1">
            <label>Código</label>
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="form.cd"
              name="cd"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cd')"
              v-if="form.errors.has('cd')"
            ></b-form-feedback>
          </b-col>
          <b-col md="4" sm="1" class="p-l-16">
            <label>Descrição</label>
            <b-form-input
              type="text"
              placeholder="Descrição"
              v-model="form.descr"
              name="descr"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('descr')"
              v-if="form.errors.has('descr')"
            ></b-form-feedback>
          </b-col>
          <b-col md="4" sm="1" class="p-l-8">
            <label>Fuso Horário</label>
            <b-form-input
              type="text"
              placeholder="Fuso Horário"
              v-model="form.horario_tz"
              name="horario_tz"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('horario_tz')"
              v-if="form.errors.has('horario_tz')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row class="mx-0 first-section-grid">
          <b-col cols="12" md="3">
            <label>Tipo de expedição</label>
            <multiselect
              v-model="tpExpedicaoSelected"
              :options="this.$parent.optionsTpExpedicao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_expedicao_transp')"
              v-if="form.errors.has('tp_expedicao_transp')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="3">
            <label>Versão Dacte</label>
            <multiselect
              v-model="versaoDacteSelected"
              :options="this.$parent.optionsVersaoDacte"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('versao_dacte')"
              v-if="form.errors.has('versao_dacte')"
            ></b-form-feedback>
          </b-col>

          <b-col cols="12" md="3">
            <label>Tipo de serviço</label>
            <multiselect
              :class="[
                'multiselect-auto-height',
                { 'multiselect-has-values': tpServicoSelected && tpServicoSelected.length }
              ]"
              v-model="tpServicoSelected"
              :options="this.$parent.optionsParamTipoServico"
              :multiple="true"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('param_tipo_servicos')"
              v-if="form.errors.has('param_tipo_servicos')"
            ></b-form-feedback>
          </b-col>

          <b-col cols="12" md="3">
            <label>Step emissão CTE/Montagem de carga</label>
            <multiselect
              v-model="stepEmissaoCteSelected"
              :options="filteredStepEmissaoCteOptions"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('step_emissao')"
              v-if="form.errors.has('step_emissao')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid class="p-0">
        <b-row class="mx-0 first-section-grid">
          <b-col cols="12" md="2">
            <label>Segmento Contábil</label>
            <b-form-input
              type="text"
              placeholder="Segmento Contábil"
              v-model="form.segmento_contabil"
              name="segmento_contabil"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('segmento_contabil')"
              v-if="form.errors.has('segmento_contabil')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="2">
            <label>Transação ERP</label>
            <b-form-input
              type="text"
              placeholder="ERP"
              v-model="form.transacao_erp"
              name="transacao_erp"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('transacao_erp')"
              v-if="form.errors.has('transacao_erp')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="2">
            <label>Tipo Unidade</label>
            <multiselect
              v-model="tpUnidadeSelected"
              :options="this.$parent.optionsLivTpUnidade"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_unidade')"
              v-if="form.errors.has('tp_unidade')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="2">
            <label>Tipo CTE</label>
            <multiselect
              v-model="livTipoCteSelected"
              :options="this.$parent.optionsLivTipoCte"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('versao_cte')"
              v-if="form.errors.has('versao_cte')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="2">
            <label>Status</label>
            <multiselect
              v-model="statusSelected"
              :options="this.$parent.optionsLivStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('status')"
              v-if="form.errors.has('status')"
            ></b-form-feedback>
          </b-col>
          <b-col cols="12" md="2">
            <label>Rateio</label>
            <multiselect
              v-model="tpRateioSelected"
              :options="this.$parent.optionsTpRateio || []"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label=""
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_rateio')"
              v-if="form.errors.has('tp_rateio')"
            ></b-form-feedback>
          </b-col>          
        </b-row>
      </b-container>
      <hr class="p-a-0 m-t m-b-0" />

      <b-container fluid class="p-0">
        <b-row>
          <b-col md="6" sm="1">
            <label>Tipo da Mensagem:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.tp_regra_montagem"
                :options="this.$parent.optionsTpRegraMontagem"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="tp_regra_montagem"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('tp_regra_montagem')"
              v-if="form.errors.has('tp_regra_montagem')"
            ></b-form-feedback>
          </b-col>

          <b-col md="6" sm="1">
            <label>Exige CTe para Mensagem:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.exige_cte_montagem_carga"
                :options="this.$parent.optionsExigeCteMontagem"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="exige_cte_montagem_carga"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('exige_cte_montagem_carga')"
              v-if="form.errors.has('exige_cte_montagem_carga')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6" sm="1">
            <label>Aplica tipo de carga cálculo despesa:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.calculo_tipo_carga"
                :options="this.$parent.optionsCalculoTipoCarga"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="calculo_tipo_carga"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('calculo_tipo_carga')"
              v-if="form.errors.has('calculo_tipo_carga')"
            ></b-form-feedback>
          </b-col>

          <b-col md="6" sm="1">
            <label>Quebra UC Receita</label>
            <multiselect
              v-model="tpQuebraUcReceitaSelected"
              :options="this.$parent.optionsTpQuebraUc"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label=""
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_quebra_uc_receita')"
              v-if="form.errors.has('tp_quebra_uc_receita')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6" sm="1">
            <label>Quebra UC Despesa</label>
            <multiselect
              v-model="tpQuebraUcDespesaSelected"
              :options="this.$parent.optionsTpQuebraUc"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label=""
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_quebra_uc_despesa')"
              v-if="form.errors.has('tp_quebra_uc_despesa')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid class="p-0">
        <b-row>
          <b-col md="6" sm="1">
            <label>Bloqueia expedição:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.bloqueia_expedicao"
                :options="this.$parent.optionsBloqueiaExpedicao"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="bloqueia_expedicao"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('bloqueia_expedicao')"
              v-if="form.errors.has('bloqueia_expedicao')"
            ></b-form-feedback>
          </b-col>

          <b-col md="6" sm="1">
            <label>Qtde horas bloqueio expedição</label>
            <b-form-input
              type="text"
              placeholder="Qtde horas bloqueio expedição"
              v-model="form.horas_bloqueio_expedicao"
              name="horas_bloqueio_expedicao"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('horas_bloqueio_expedicao')"
              v-if="form.errors.has('horas_bloqueio_expedicao')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6" sm="1">
            <label>Valida ajudante na GR:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.valida_ajudante"
                :options="this.$parent.optionsValidaAjudante"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="valida_ajudante"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('valida_ajudante')"
              v-if="form.errors.has('valida_ajudante')"
            ></b-form-feedback>
          </b-col>

          <b-col md="6" sm="1">
            <label>Valida NFs canceladas:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.valida_nfs_canceladas"
                :options="this.$parent.optionsValidaNfsCanceladas"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="valida_nfs_canceladas"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('valida_nfs_canceladas')"
              v-if="form.errors.has('valida_nfs_canceladas')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6" sm="1">
            <label>Bloqueio de ocorrências após entrega:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.param_bloqueia_ocorrencia"
                :options="this.$parent.optionsParamBloqueiaOcorrencia"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="param_bloqueia_ocorrencia"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('param_bloqueia_ocorrencia')"
              v-if="form.errors.has('param_bloqueia_ocorrencia')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>

      <hr class="p-a-0 m-t m-b-0" />

      <b-container fluid class="p-0">
        <b-row>
          <b-col md="4" sm="1">
            <label> PROCESSOS - NÃO AGRUPAMENTO RECEITA </label>
            <multiselect
              v-model="tp_processo"
              :multiple="true"
              :options="this.$parent.optionsTpProcesso"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_processo')"
              v-if="form.errors.has('tp_processo')"
            ></b-form-feedback>
          </b-col>

          <b-col md="4" sm="1">
            <label>Realiza triagem?</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.triagem"
                :options="this.$parent.optionsTriagem"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="triagem"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('triagem')"
              v-if="form.errors.has('triagem')"
            ></b-form-feedback>
          </b-col>

          <b-col md="4" sm="1">
            <label>Utiliza modulo de conferência?</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.utiliza_modulo_conferencia"
                :options="this.$parent.optionsModuloConferencia"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="conferencia"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('utiliza_modulo_conferencia')"
              v-if="form.errors.has('utiliza_modulo_conferencia')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" sm="1">
            <label>Tipo da Atividade</label>
            <multiselect
              v-model="tpAtividadeSelected"
              :multiple="false"
              :options="this.$parent.optionsTpAtividade"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_atividade')"
              v-if="form.errors.has('tp_atividade')"
            ></b-form-feedback>
          </b-col>

          <b-col md="4" sm="1">
            <label>Imprime notas por manifesto?</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.integracao_notas_por_manifesto"
                :options="this.$parent.optionsIntegracaoNotasPorManifesto"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="integracao_notas_por_manifesto"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('integracao_notas_por_manifesto')"
              v-if="form.errors.has('integracao_notas_por_manifesto')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" sm="1">
            <label>Destaque de notas em vencimento</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.aviso_vencimento"
                :options="this.$parent.optionsAvisoVencimento"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="aviso_vencimento"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('aviso_vencimento')"
              v-if="form.errors.has('aviso_vencimento')"
            ></b-form-feedback>
          </b-col>

          <b-col md="8" sm="1">
            <label>Dias de aviso</label>
            <input
              :disabled="form.aviso_vencimento==2"
              type="number"
              v-model.number="form.dias_vencimento"
              min="0"
              max="180"
              class="form-control"
            />
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('dias_vencimento')"
              v-if="form.errors.has('dias_vencimento')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid class="p-a-0">
        <b-row>
          <label>Observação</label>
          <b-form-textarea
            id="textarea1"
            name="obs"
            v-model="form.obs"
            placeholder="Observação"
            :rows="6"
            :max-rows="6"
          >
          </b-form-textarea>
        </b-row>
      </b-container>
      <hr class="p-a-0 m-t m-b-0" />
      <div class="tbl-row p-a-0">
        <div class="tbl-cell tbl-cell-title">
          <h5 class="m-a-0">Dados</h5>
        </div>
      </div>

      <b-container fluid class="p-a-0">
        <b-row>
          <b-col md="3" sm="1">
            <label>CNPJ</label>
            <b-form-input
              type="text"
              placeholder="CNPJ"
              v-model="cnpj"
              v-mask="mascaraCNPJ"
              name="cnpj"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cnpj')"
              v-if="form.errors.has('cnpj')"
            ></b-form-feedback>
          </b-col>

          <b-col md="3" sm="1">
            <label>Nome Fantasia</label>
            <b-form-input
              type="text"
              placeholder="Nome Fantasia"
              v-model="form.nome_fantasia"
              name="nome_fantasia"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('nome_fantasia')"
              v-if="form.errors.has('nome_fantasia')"
            ></b-form-feedback>
          </b-col>

          <b-col md="3" sm="1">
            <label>Razão Social</label>
            <b-form-input
              type="text"
              placeholder="Razão Social"
              v-model="form.razao_social"
              name="razao_social"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('razao_social')"
              v-if="form.errors.has('razao_social')"
            ></b-form-feedback>
          </b-col>

          <b-col md="3" sm="1">
            <label>Inscrição Estadual</label>
            <b-form-input
              type="text"
              placeholder="Inscrição Estadual"
              v-model="form.inscricao_estadual"
              name="inscricao_estadual"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('inscricao_estadual')"
              v-if="form.errors.has('inscricao_estadual')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="3" sm="1">
            <label>Inscrição Municipal</label>
            <b-form-input
              type="text"
              placeholder="Inscrição Municipal"
              v-model="form.inscricao_municipal"
              name="inscricao_municipal"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('inscricao_municipal')"
              v-if="form.errors.has('inscricao_municipal')"
            ></b-form-feedback>
          </b-col>

          <b-col md="3" sm="1">
            <label>Inscrição Suframa</label>
            <b-form-input
              type="text"
              placeholder="Inscrição Suframa"
              v-model="form.inscricao_suframa"
              name="inscricao_suframa"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('inscricao_suframa')"
              v-if="form.errors.has('inscricao_suframa')"
            ></b-form-feedback>
          </b-col>

          <b-col md="3" sm="1">
            <label>Código Regime Tributário</label>
            <b-form-input
              type="text"
              placeholder="Código Regime Tributário"
              v-model="form.cd_regime_tributario"
              name="cd_regime_tributario"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cd_regime_tributario')"
              v-if="form.errors.has('cd_regime_tributario')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <hr class="p-a-0 m-t m-b-0" />
      <div class="tbl-row">
        <div class="tbl-cell tbl-cell-title">
          <h5 class="m-a-0">Endereço</h5>
        </div>
      </div>
      <b-container fluid class="p-a-0">
        <b-row>
          <b-col>
            <label>CEP</label>
            <b-form-input
              type="text"
              placeholder="CEP"
              v-model="form.cep"
              name="cep"
              @change="getCep()"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cep')"
              v-if="form.errors.has('cep')"
            ></b-form-feedback>
          </b-col>
          <b-col class="p-l-0">
            <label>Bairro</label>
            <b-form-input
              type="text"
              placeholder="Bairro"
              v-model="form.bairro"
              name="bairro"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('bairro')"
              v-if="form.errors.has('bairro')"
            ></b-form-feedback>
          </b-col>
          <b-col class="p-l-0">
            <label>Número</label>
            <b-form-input
              type="text"
              placeholder="Número"
              v-model="form.numero"
              name="numero"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('numero')"
              v-if="form.errors.has('numero')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Complemento</label>
            <b-form-input
              type="text"
              placeholder="Complemento"
              v-model="form.complemento"
              name="complemento"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('complemento')"
              v-if="form.errors.has('complemento')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid class="p-a-0">
        <b-row>
          <b-col>
            <label>Endereço</label>
            <b-form-input
              type="text"
              placeholder="Endereço"
              v-model="form.endereco"
              name="endereco"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('endereco')"
              v-if="form.errors.has('endereco')"
            ></b-form-feedback>
          </b-col>
          <b-col class="p-l-0">
            <label>Município</label>

            <multiselect
              v-model="municipoSelected"
              :options="this.$parent.optionsMunicipio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('municipio_id')"
              v-if="form.errors.has('municipio_id')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <hr class="p-a-0 m-t m-b-0" />
      <div class="tbl-row">
        <div class="tbl-cell tbl-cell-title">
          <h5 class="m-a-0">Rota</h5>
        </div>
      </div>
      <b-container fluid class="p-0 rota-grid">
        <b-row>
          <b-col class="p-l-0">
            <label>Otimizar rota por:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.rota_otimizacao"
                :options="this.$parent.optionsRotaOtimizacao"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="rota_otimizacao"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('rota_otimizacao')"
              v-if="form.errors.has('rota_otimizacao')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Evitar pedágio:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.rota_evitar_pedagio"
                :options="this.$parent.optionsRotaEvitarPedagio"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="rota_evitar_pedagio"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('rota_evitar_pedagio')"
              v-if="form.errors.has('rota_evitar_pedagio')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Evitar balsa:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.rota_evitar_balsa"
                :options="this.$parent.optionsRotaEvitarBalsa"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="rota_evitar_balsa"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('rota_evitar_balsa')"
              v-if="form.errors.has('rota_evitar_balsa')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Evitar estrada de terra:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.rota_evitar_estrada_terra"
                :options="this.$parent.optionsRotaEvitarEstradaTerra"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="rota_evitar_estrada_terra"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('rota_evitar_estrada_terra')"
              v-if="form.errors.has('rota_evitar_estrada_terra')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Restringir a 8 horas:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_tempo_8h"
                :options="this.$parent.optionsRestringirTempo8h"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_tempo_8h"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_tempo_8h')"
              v-if="form.errors.has('restringir_tempo_8h')"
            ></b-form-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="p-l-0">
            <label>Restringir Horário comercial:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_horario_comercial"
                :options="this.$parent.optionsRestringirHorarioComercial"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_horario_comercial"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_horario_comercial')"
              v-if="form.errors.has('restringir_horario_comercial')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Restringir Horário ponto de parada:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_horario_ponto_parada"
                :options="this.$parent.optionsRestringirHorarioPontoParada"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_horario_ponto_parada"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_horario_ponto_parada')"
              v-if="form.errors.has('restringir_horario_ponto_parada')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Restringir zona de circulação de SP:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_zona_circulacao_sp"
                :options="this.$parent.optionsRestringirZonaCirculacaoSp"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_zona_circulacao_sp"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_zona_circulacao_sp')"
              v-if="form.errors.has('restringir_zona_circulacao_sp')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Restringir zona de rodízio:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_zona_rodizio"
                :options="this.$parent.optionsRestringirZonaRodizio"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_zona_rodizio"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_zona_rodizio')"
              v-if="form.errors.has('restringir_zona_rodizio')"
            ></b-form-feedback>
          </b-col>

          <b-col class="p-l-0">
            <label>Restringir zona de logística:</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.restringir_zonas_logisticas"
                :options="this.$parent.optionsRestringirZonasLogisticas"
                class="radio-circle-black"
                style="margin-right: 5px"
                name="restringir_zonas_logisticas"
                plain
                stacked
                value-field="value"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form.errors.get('restringir_zonas_logisticas')"
              v-if="form.errors.has('restringir_zonas_logisticas')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <b-btn
          @click="showModal = false"
          variant="secondary"
          class="unidade-btn-close"
        >
          Fechar
        </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
          class="unidade-btn-save"
        >
          Salvar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";
import { buildCNPJFromParts, formatCNPJ } from "../utils";

import { formatCNPJFromParts } from "../utils";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      mascaraCNPJ: "XX.XXX.XXX/XXXX-XX",
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      livTipoCteSelected: [],
      tpUnidadeSelected: [],
      tp_processo: [],
      tp_processo_values: [],
      tpUnidadeSelected: [],
      statusSelected: [],
      tpRateioSelected: [],
      tpQuebraUcReceitaSelected: [],
      tpQuebraUcDespesaSelected: [],
      municipoSelected: [],
      versaoDacteSelected: [],
      tpServicoSelected: [],
      tpExpedicaoSelected: [],
      stepEmissaoCteSelected: [],
      isHydratingEdit: false,
      bairroSelected: [],
      tpAtividadeSelected: null,
      cnpj: "",
      errors_array: [],
      helpForm: new Form({
        cep_busca: "",
        statusRecord: [],
        params: [],
      }),
      form: new Form({
        cd: "",
        tp_unidade: "",
        descr: "",
        horario_tz: "",
        horas_bloqueio_expedicao: "",
        status: "",
        versao_cte: "",
        cnpj: "",
        razao_social: "",
        nome_fantasia: "",
        inscricao_estadual: "",
        inscricao_municipal: "",
        inscricao_suframa: "",
        cd_regime_tributario: "",
        cep: "",
        bairro: "",
        endereco: "",
        numero: "",
        complemento: "",
        pesend_id: "",
        transacao_erp: "",
        segmento_contabil: "",
        municipio_id: "",
        tp_regra_montagem: "",
        exige_cte_montagem_carga: "",
        bloqueia_expedicao: "",
        valida_ajudante: "",
        valida_nfs_canceladas: "",
        calculo_tipo_carga: "",
        param_bloqueia_ocorrencia: "",
        triagem: "",
        tp_quebra_uc_receita: "",
        tp_quebra_uc_despesa: "",
        tp_rateio: "",
        tp_processo: [],
        tp_expedicao_transp: "",
        param_tipo_servicos: [],
        step_emissao: "",
        versao_dacte: "",
        tp_atividade: null,
        rota_otimizacao: "",
        rota_evitar_pedagio: "",
        rota_evitar_balsa: "",
        rota_evitar_estrada_terra: "",
        restringir_tempo_8h: "",
        restringir_horario_comercial: "",
        restringir_horario_ponto_parada: "",
        restringir_zona_circulacao_sp: "",
        restringir_zona_rodizio: "",
        restringir_zonas_logisticas: "",
        integracao_notas_por_manifesto: "",
        obs: "",
        aviso_vencimento: 1,
        dias_vencimento: 0,
        utiliza_modulo_conferencia: null
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    tpQuebraUcReceitaSelected(obj) {
      this.form.tp_quebra_uc_receita = obj ? obj.value : "";
    },
    tpQuebraUcDespesaSelected(obj) {
      this.form.tp_quebra_uc_despesa = obj ? obj.value : "";
    },
    tpRateioSelected(obj) {
      this.form.tp_rateio = obj ? obj.value : "";
    },
    livTipoCteSelected(obj) {
      this.form.versao_cte = obj ? obj.value : "";
    },
    tpUnidadeSelected(obj) {
      this.form.tp_unidade = obj ? obj.value : "";
    },
    statusSelected(obj) {
      this.form.status = obj ? obj.value : "";
    },
    municipoSelected(obj) {
      this.form.municipio_id = obj ? obj.value : "";
    },
    tpExpedicaoSelected(obj) {
      this.form.tp_expedicao_transp = obj ? obj.value : "";
    },
    tpServicoSelected(obj) {
      this.form.param_tipo_servicos = this.getParamTipoServicosValues(obj);
      if (!this.isHydratingEdit) {
        this.$nextTick(() => this.revalidateStepEmissaoIfInvalid());
      }
    },
    stepEmissaoCteSelected(obj) {
      this.form.step_emissao = obj ? obj.value : "";
    },
    bairroSelected(obj) {
      this.form.bairro = obj ? obj.value : "";
    },
    versaoDacteSelected(obj) {
      this.form.versao_dacte = obj ? obj.value : "";
    },
    tpAtividadeSelected(obj) {
      this.form.tp_atividade = obj ? obj.value : null;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    /**
     * Normaliza a seleção de tipo de serviço para array de valores (form.param_tipo_servicos).
     * @param {Object|Object[]|null} selection - item(s) selecionado(s) no multiselect
     * @returns {Array<number|string>}
     */
    getParamTipoServicosValues(selection) {
      if (Array.isArray(selection)) {
        return selection
          .filter((item) => item && item.value !== undefined)
          .map((item) => item.value);
      }
      if (selection && selection.value !== undefined) {
        return [selection.value];
      }
      return [];
    },
    /**
     * Verifica se o step de emissão atual ainda pertence à lista de opções permitidas.
     * @param {Object|null} stepOption - step selecionado { value, label }
     * @param {Array<{ value }>} allowedOptions - opções filtradas por tipo de serviço
     * @returns {boolean}
     */
    isStepInAllowedOptions(stepOption, allowedOptions) {
      if (!stepOption || !allowedOptions || !allowedOptions.length) return false;
      return allowedOptions.some(
        (opt) => String(opt.value) === String(stepOption.value)
      );
    },
    /**
     * Limpa Step emissão CTE se o valor atual não for mais válido
     * para os tipos de serviço selecionados (ex.: tipo removido).
     */
    revalidateStepEmissaoIfInvalid() {
      const allowedOptions = this.filteredStepEmissaoCteOptions;
      const currentStep = this.stepEmissaoCteSelected;
      if (this.isStepInAllowedOptions(currentStep, allowedOptions)) return;
      this.stepEmissaoCteSelected = null;
      this.form.step_emissao = "";
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.unidade_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.cnpj = "";
      this.tpQuebraUcReceitaSelected = [];
      this.tpQuebraUcDespesaSelected = [];
      this.tpRateioSelected = [];
      this.livTipoCteSelected = [];
      this.tpUnidadeSelected = [];
      this.tp_processo = [];
      this.tp_processo_values = [];
      this.statusSelected = [];
      this.municipoSelected = [];
      this.tpExpedicaoSelected = [];
      this.tpServicoSelected = [];
      this.versaoDacteSelected = [];
      this.stepEmissaoCteSelected = [];
      this.bairroSelected = [];
      const defaultTpAtividade = this.$parent.optionsTpAtividade.find(option => option.value == 4);
      this.tpAtividadeSelected = defaultTpAtividade || null;
      this.form.tp_regra_montagem = 2;
      this.form.exige_cte_montagem_carga = 2;
      this.form.bloqueia_expedicao = 2;
      this.form.valida_ajudante = 2;
      this.form.valida_nfs_canceladas = 2;
      this.form.calculo_tipo_carga = 2;
      this.form.rota_otimizacao = 3;
      this.form.rota_evitar_pedagio = 2;
      this.form.rota_evitar_balsa = 2;
      this.form.rota_evitar_estrada_terra = 2;
      this.form.param_bloqueia_ocorrencia = 2;
      this.form.triagem = 2;
      this.form.utiliza_modulo_conferencia = 2;
      this.form.restringir_tempo_8h = 2;
      this.form.restringir_horario_comercial = 2;
      this.form.restringir_horario_ponto_parada = 2;
      this.form.restringir_zona_circulacao_sp = 2;
      this.form.restringir_zona_rodizio = 2;
      this.form.restringir_zonas_logisticas = 2;
      this.form.integracao_notas_por_manifesto = 2;
      this.form.aviso_vencimento = 1;
      this.form.dias_vencimento = 0;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isHydratingEdit = true;
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.tp_processo = [];
      this.tp_processo_values = [];
      this.tpQuebraUcReceitaSelected = [];
      this.tpQuebraUcDespesaSelected = [];
      this.livTipoCteSelected = [];
      this.tpUnidadeSelected = [];
      this.statusSelected = [];
      this.tpRateioSelected = [];
      this.tpExpedicaoSelected = [];
      this.tpServicoSelected = [];
      this.versaoDacteSelected = [];
      this.tpAtividadeSelected = null;
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.livTipoCteSelected = {
        label: data.liv_tipo_cte.descr,
        value: data.liv_tipo_cte.valor,
      };
      this.tpUnidadeSelected = {
        label: data.tp_unidade.descr,
        value: data.tp_unidade.valor,
      };
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor,
      };
      this.tpExpedicaoSelected = {
        label: data.liv_tipo_expedicao_transp.descr,
        value: data.liv_tipo_expedicao_transp.valor,
      };
      const mapTipoServicoToOption = (item) => {
        if (item === null || item === undefined || item === "") {
          return null;
        }

        if (typeof item === "object") {
          if (item.descr !== undefined && item.valor !== undefined) {
            return {
              label: item.descr,
              value: item.valor,
            };
          }

          if (item.label !== undefined && item.value !== undefined) {
            return {
              label: item.label,
              value: item.value,
            };
          }

          const itemValue =
            item.value !== undefined
              ? item.value
              : item.valor !== undefined
              ? item.valor
              : item.partpserv_id;

          if (itemValue !== undefined && itemValue !== null && itemValue !== "") {
            const match = (this.$parent.optionsParamTipoServico || []).find(
              (option) => String(option.value) === String(itemValue)
            );
            if (match) {
              return {
                label: match.label,
                value: match.value,
              };
            }
            return {
              label: item.descr || item.label || String(itemValue),
              value: itemValue,
            };
          }

          return null;
        }

        const match = (this.$parent.optionsParamTipoServico || []).find(
          (option) => String(option.value) === String(item)
        );
        if (match) {
          return {
            label: match.label,
            value: match.value,
          };
        }
        return {
          label: String(item),
          value: item,
        };
      };

      const rawServicos =
        data.param_tipo_servicos !== undefined
          ? data.param_tipo_servicos
          : data.tp_servico;

      const servicos = Array.isArray(rawServicos)
        ? rawServicos
        : rawServicos !== undefined && rawServicos !== null
        ? [rawServicos]
        : [];

      this.tpServicoSelected = servicos
        .map((item) => mapTipoServicoToOption(item))
        .filter((item) => item && item.value !== undefined);

      const rawStepEmissao =
        data.step_emissao !== undefined
          ? data.step_emissao
          : data.step_emissao_cte;

      const stepValue =
        rawStepEmissao && typeof rawStepEmissao === "object"
          ? rawStepEmissao.value !== undefined
            ? rawStepEmissao.value
            : rawStepEmissao.valor
          : rawStepEmissao;

      if (stepValue !== undefined && stepValue !== null && stepValue !== "") {
        const stepOptions = this.filteredStepEmissaoCteOptions;
        const stepOptionByFilteredList = stepOptions.find(
          (option) => String(option.value) === String(stepValue)
        );
        const stepOptionByAllOptions = (this.$parent.optionsStepEmissaoCte || []).find(
          (option) => String(option.value) === String(stepValue)
        );

        this.stepEmissaoCteSelected =
          stepOptionByFilteredList ||
          stepOptionByAllOptions || {
            label: mapTipoServicoToOption(stepValue).label,
            value: stepValue,
          };
        this.form.step_emissao = stepValue;
      } else {
        this.stepEmissaoCteSelected = [];
        this.form.step_emissao = "";
      }
      this.versaoDacteSelected = {
        label: data.liv_versao_dacte.descr,
        value: data.liv_versao_dacte.valor,
      };
      this.tpAtividadeSelected = {
        label: data.tp_atividade.descr,
        value: data.tp_atividade.valor,
      };
      this.tpQuebraUcReceitaSelected = {
        label: data.tp_quebra_uc_receita.descr,
        value: data.tp_quebra_uc_receita.valor,
      };
      this.tpQuebraUcDespesaSelected = {
        label: data.tp_quebra_uc_despesa.descr,
        value: data.tp_quebra_uc_despesa.valor,
      };
      this.tpRateioSelected = {
        label: data.liv_tipo_rateio.descr,
        value: data.liv_tipo_rateio.valor,
      };
      if (data.unidade_agrupamento_receita.length > 0){
        data.unidade_agrupamento_receita.forEach((obj) =>{
          this.tp_processo.push({
            label:obj.tp_processo.descr,
            value:obj.tp_processo.valor,
            uniagrures_id:obj.uniagrures_id
          })
        });
      }
      this.form.tp_regra_montagem = data.tp_regra_montagem.valor;
      this.form.rota_otimizacao = data.rota_otimizacao;
      this.form.rota_evitar_pedagio = data.rota_evitar_pedagio;
      this.form.rota_evitar_balsa = data.rota_evitar_balsa;
      this.form.rota_evitar_estrada_terra = data.rota_evitar_estrada_terra;
      this.form.restringir_tempo_8h = data.restringir_tempo_8h;
      this.form.restringir_horario_comercial =
        data.restringir_horario_comercial;
      this.form.restringir_horario_ponto_parada =
        data.restringir_horario_ponto_parada;
      this.form.restringir_zona_circulacao_sp =
        data.restringir_zona_circulacao_sp;
      this.form.restringir_zona_rodizio = data.restringir_zona_rodizio;
      this.form.restringir_zonas_logisticas = data.restringir_zonas_logisticas;
      this.form.horario_tz = data.horario_tz;
      this.form.horas_bloqueio_expedicao = data.horas_bloqueio_expedicao;
      this.form.transacao_erp = data.transacao_erp;
      this.form.obs = data.obs;
      this.form.segmento_contabil = data.segmento_contabil;
      this.form.exige_cte_montagem_carga = data.exige_cte_montagem_carga;
      this.form.param_bloqueia_ocorrencia = data.param_bloqueia_ocorrencia.valor;
      this.form.triagem = data.triagem.valor;
      this.form.utiliza_modulo_conferencia = data.utiliza_modulo_conferencia.valor;
      this.form.bloqueia_expedicao = data.bloqueia_expedicao;
      this.form.valida_ajudante = data.valida_ajudante;
      this.form.valida_nfs_canceladas = data.valida_nfs_canceladas;
      this.form.calculo_tipo_carga = data.calculo_tipo_carga;
      this.form.versao_cte = data.versao_cte.valor;
      this.form.pessoa_id = data.pessoa_id;
      this.form.unidade_id = data.unidade_id;
      this.form.tp_unidade = {
        label: data.tp_unidade.descr,
        value: data.tp_unidade.valor,
      };
      this.form.integracao_notas_por_manifesto = data.integracao_notas_por_manifesto.valor;
      this.form.status = { label: data.status.descr, value: data.status.valor };

      this.cnpj = formatCNPJ(
        buildCNPJFromParts(
          data.pessoa.pessoa_juridica.cnpj_base,
          data.pessoa.pessoa_juridica.cnpj_filial,
          data.pessoa.pessoa_juridica.cnpj_digito
        )
      );

      this.form.razao_social = data.pessoa.pessoa_juridica.razao_social;
      this.form.nome_fantasia = data.pessoa.pessoa_juridica.nome_fantasia;
      this.form.inscricao_estadual =
        data.pessoa.pessoa_juridica.inscricao_estadual;
      this.form.inscricao_municipal =
        data.pessoa.pessoa_juridica.inscricao_municipal;
      this.form.inscricao_suframa =
        data.pessoa.pessoa_juridica.inscricao_suframa;
      this.form.cd_regime_tributario =
        data.pessoa.pessoa_juridica.cd_regime_tributario;

      this.form.cep = data.pessoa_endereco.cep;
      this.form.bairro = data.pessoa_endereco.bairro;
      this.form.endereco = data.pessoa_endereco.endereco;
      this.form.numero = data.pessoa_endereco.numero;
      this.form.complemento = data.pessoa_endereco.complemento;
      this.form.pesend_id = data.pessoa_endereco.pesend_id;
      this.municipoSelected = {
        label: data.pessoa_endereco.municipio.nome,
        value: data.pessoa_endereco.municipio.municipio_id,
      };
      this.form.aviso_vencimento = data.aviso_vencimento.valor;
      this.form.dias_vencimento = data.dias_vencimento;
      this.$nextTick(() => {
        this.isHydratingEdit = false;
      });
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.param_tipo_servicos = Array.isArray(this.tpServicoSelected)
        ? this.tpServicoSelected
            .filter((item) => item && item.value !== undefined)
            .map((item) => item.value)
        : [];
      this.form.step_emissao =
        this.stepEmissaoCteSelected && this.stepEmissaoCteSelected.value != null
          ? this.stepEmissaoCteSelected.value
          : null;
      this.tp_processo_values = [];
      this.form.tp_processo = [];
      this.tp_processo.forEach((obj)=>{
        this.tp_processo_values.push(obj.value);
      })
      this.form.tp_processo = this.tp_processo_values;
      this.form.cep = Number(this.form.cep).toString().replace(/\D/g, "");
      this.form.cnpj = this.cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      if(this.form.aviso_vencimento == 2){
        this.form.dias_vencimento = null
      }
      else if(this.form.dias_vencimento == null){
          this.form.dias_vencimento = 0
      }
      this.form
        .post("/api/unidade/store")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.param_tipo_servicos = Array.isArray(this.tpServicoSelected)
        ? this.tpServicoSelected
            .filter((item) => item && item.value !== undefined)
            .map((item) => item.value)
        : [];
      this.form.step_emissao =
        this.stepEmissaoCteSelected && this.stepEmissaoCteSelected.value != null
          ? this.stepEmissaoCteSelected.value
          : null;
      this.form.tp_processo = this.tp_processo.map((obj) => {
        return obj.value;
      });
      this.form.cep = Number(this.form.cep).toString().replace(/\D/g, "");
      this.form.cnpj = this.cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      if(this.form.aviso_vencimento == 2){
        this.form.dias_vencimento = null
      }
      else if(this.form.dias_vencimento == null){
          this.form.dias_vencimento = 0
      }
      this.form
        .patch("/api/unidade/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.form.cnpj = this.ajustaMascaraForm(this.form.cnpj);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getCep(index) {
      this.helpForm.cep_busca = this.form.cep;

      //Nova variável "cep" somente com dígitos.
      var cep = this.helpForm.cep_busca.replace(/\D/g, "");

      //Verifica se campo cep possui valor informado.
      if (cep != "") {
        //Expressão regular para validar o CEP.
        var validacep = /^[0-9]{8}$/;

        //Valida o formato do CEP.
        if (validacep.test(cep)) {
          this.loadingCep = true;
          this.helpForm
            .post("/api/cep/pesquisar")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);

              this.helpForm.errors.clear();
              response.forEach((obj) => {
                this.form.endereco = obj.logradouro;
                this.form.bairro = obj.bairro;
                this.$parent.optionsMunicipio.forEach((obj2) => {
                  if (obj2.ibge == obj.ibge) {
                    this.municipoSelected = {
                      label: obj2.label,
                      value: obj2.value,
                    };
                  }
                });
              });
              this.loadingCep = false;
            })
            .catch((errors) => {
              this.loadingCep = false;
              new ReturnApi(errors, this);
            });
        } else {
          var errors = {
            errors: {
              emi_cep: ["Cep inválido"],
            },
          };
          this.helpForm.errors.record(errors.errors);
        }
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/unidade/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/icms/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach((obj) => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.uf.forEach((obj) => {
            this.optionsUf.push({ label: obj.nome, value: obj.uf_id });
          });
          response.tp_icms.forEach((obj) => {
            this.optionsLivTpIcms.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    ajustaMascaraForm(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    filteredStepEmissaoCteOptions() {
      const options = this.$parent.optionsStepEmissaoCte || [];
      const selectedTpServico = Array.isArray(this.form.param_tipo_servicos)
        ? this.form.param_tipo_servicos.map((value) => String(value))
        : [];

      if (selectedTpServico.length === 0) {
        return [];
      }

      const getIds = (value) => {
        if (value === null || value === undefined) {
          return [];
        }
        if (Array.isArray(value)) {
          return value
            .map((item) => {
              if (item && typeof item === "object") {
                return item.value || item.valor || item.partpserv_id || item.tp_servico;
              }
              return item;
            })
            .filter((item) => item !== null && item !== undefined)
            .map((item) => String(item));
        }
        if (typeof value === "object") {
          const extracted =
            value.value || value.valor || value.partpserv_id || value.tp_servico;
          return extracted !== null && extracted !== undefined
            ? [String(extracted)]
            : [];
        }
        return [String(value)];
      };

      const selectedTpServicoOptions = Array.isArray(this.tpServicoSelected)
        ? this.tpServicoSelected
            .filter((item) => item && item.value !== undefined)
            .map((item) => ({ label: item.label, value: item.value }))
        : [];

      if (options.length === 0) {
        return selectedTpServicoOptions;
      }

      return options.filter((option) => {
        const relationIds = [
          ...getIds(option.partpserv_id),
          ...getIds(option.tp_servico),
          ...getIds(option.tp_servico_id),
          ...getIds(option.tp_servico_ids),
          ...getIds(option.tp_servicos),
          ...getIds(option.param_tipo_servico_id),
          ...getIds(option.tipo_servico_id),
        ];

        if (relationIds.length === 0) {
          return true;
        }

        return relationIds.some((id) => selectedTpServico.includes(id));
      });
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>

<style>
.radio-circle-black input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  margin-right: 0;
  background-color: #e7e7e7;
  border-radius: 50%;
  box-shadow: 0px 1px 2px 0px #0000000D;
  border: 1px solid #e7e7e7;
  opacity: 1;
}

.radio-circle-black input[type="radio"]:checked {
  background-color: #e7e7e7;
  background-image: url('/images/icons/radio-dot.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 18px 18px;
}

.radio-circle-black .form-check-label,
.radio-circle-black .custom-control-label {
  margin-left: 8px !important;
}

.radio-circle-black .form-check,
.radio-circle-black .custom-control {
  margin-bottom: 4px;
}

.unidade-btn-close,
.unidade-btn-save {
  height: 36px !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.unidade-btn-close {
  width: 79px !important;
  border: 1px solid #45556C !important;
  background: #ffffff !important;
  color: #45556C !important;
}

.unidade-btn-save {
  width: 73px !important;
  border: 1px solid #45556C !important;
  background: #45556C !important;
  color: #ffffff !important;
  margin-left: 8px !important;
}

.rota-grid label {
  white-space: nowrap;
}

.unidade-form .multiselect__select:before {
  content: "";
  border: 0 !important;
  width: 16px;
  height: 16px;
  top: 50%;
  right: 12px;
  margin-top: 0;
  position: absolute;
  transform: translateY(-50%);
  background: url('/images/icons/chevron-down.svg') no-repeat center;
  background-size: 16px 16px;
}

.unidade-form .multiselect--active .multiselect__select:before {
  transform: translateY(-50%) rotate(180deg);
}

.unidade-form input::placeholder,
.unidade-form textarea::placeholder {
  font-size: 14px !important;
  color: #CAD5E2 !important;
  opacity: 1;
}

.unidade-form .multiselect__placeholder {
  font-size: 14px !important;
  color: #CAD5E2 !important;
  opacity: 1;
}

.unidade-form .form-control,
.unidade-form .multiselect__input,
.unidade-form .multiselect__single,
.unidade-form .multiselect__option,
.unidade-form .multiselect__option span,
.unidade-form label,
.unidade-form .form-check-label,
.unidade-form .custom-control-label {
  font-size: 14px !important;
}

.unidade-modal-custom .modal-body .unidade-form input,
.unidade-modal-custom .modal-body .unidade-form textarea,
.unidade-modal-custom .modal-body .unidade-form .form-control,
.unidade-modal-custom .modal-body .unidade-form .multiselect,
.unidade-modal-custom .modal-body .unidade-form .multiselect *,
.unidade-modal-custom .modal-body .unidade-form label,
.unidade-modal-custom .modal-body .unidade-form .form-check,
.unidade-modal-custom .modal-body .unidade-form .form-check *,
.unidade-modal-custom .modal-body .unidade-form .custom-control,
.unidade-modal-custom .modal-body .unidade-form .custom-control * {
  font-size: 14px !important;
}

.unidade-form .first-section-grid label {
  white-space: nowrap;
}

.unidade-form .form-control,
.unidade-form .multiselect__tags {
  padding-left: 12px !important;
  padding-right: 12px !important;
  border-radius: 8px !important;
  border-width: 1px !important;
  opacity: 1;
}

.unidade-form .multiselect__tags {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.unidade-form .first-section-grid .form-control,
.unidade-form .first-section-grid .multiselect__tags {
  height: 36px !important;
  min-height: 36px !important;
  border-radius: 8px !important;
  border-width: 1px !important;
}

.unidade-form .first-section-grid .multiselect__single,
.unidade-form .first-section-grid .multiselect__placeholder {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 20px !important;
}

.unidade-form .first-section-grid .multiselect.multiselect-auto-height .multiselect__tags {
  height: 36px !important;
  min-height: 36px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  display: flex;
  align-items: center;
}

.unidade-form .first-section-grid .multiselect.multiselect-auto-height .multiselect__single,
.unidade-form .first-section-grid .multiselect.multiselect-auto-height .multiselect__placeholder {
  margin-bottom: 0 !important;
  line-height: 36px !important;
}

.unidade-form .first-section-grid .multiselect.multiselect-auto-height.multiselect-has-values .multiselect__tags {
  height: auto !important;
  min-height: 36px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  align-items: flex-start;
}

.unidade-form .first-section-grid .multiselect.multiselect-auto-height .multiselect__tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.unidade-form .row:not(.first-section-grid) {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.unidade-modal-custom .modal-dialog {
  width: 1390px;
  max-width: 1390px;
}

.unidade-modal-custom .modal-content {
  border-radius: 10px;
  border: 1px solid #ccc;
}

.unidade-modal-header {
  padding: 25px;
  padding-bottom: 15px;
  border-bottom: none;
  position: relative;
  font-size: 24px;
}

.unidade-modal-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 25px;
  right: 25px;
  height: 1px;
  background-color: #e0e0e0;
}

.unidade-modal-body {
  padding: 20px 25px;
}

.unidade-modal-footer {
  padding: 15px 25px;
  border-top: 1px solid #e0e0e0;
}

.unidade-modal-custom .form-control {
  background-color: #f8fafc;
  border: none;
  color: #333;
}

.unidade-modal-custom .form-control:focus {
  background-color: #f8fafc;
  border: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.unidade-modal-custom .multiselect {
  border: none;
}

.unidade-modal-custom .multiselect__tags {
  background-color: #f8fafc;
  border: none;
}

.unidade-modal-custom .multiselect__input,
.unidade-modal-custom .multiselect__single {
  background-color: #f8fafc;
}

.unidade-form .col,
.unidade-form [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 16px !important;
}
</style>